import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => (
    <div>
        <div className="gridWrapper">
            <div className="gridWrapper__section heroGrid">
                <Link to="catalog/3/1">
                    <img src="/images/b2.jpg" alt="Banner" />
                </Link>
            </div>
            <div className="gridWrapper__section smallGrid">
                <div>
                    <Link to="catalog/17/1">
                        <img src="/images/p1.jpg" alt="Banner" />
                        <strong>Shop Category 2 &rsaquo;</strong>
                    </Link>
                </div>
                <div>
                    <Link to="catalog/27/1">
                        <img src="/images/p2.jpg" alt="Banner" />
                        <strong>Shop Category 3 &rsaquo;</strong>
                    </Link>
                </div>
                <div>
                    <Link to="catalog/28/1">
                        <img src="/images/p3.jpg" alt="Banner" />
                        <strong>Shop Category 4 &rsaquo;</strong>
                    </Link>
                </div>
            </div>
            <div className="gridWrapper__section heroGrid">
                <Link to="catalog/31/1">
                    <img src="/images/b1.jpg" alt="Banner" />
                </Link>
            </div>
        </div>
    </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/modules/Home/Home.jsx